import { Tooltip, TooltipProps } from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import { createStyles, makeStyles } from "@material-ui/styles";
import * as React from "react";

import { RelodeTheme } from "../";
import { mergeClasses, MessageComposer, MessageComposerProps } from "../..";
import { NewMessageIcon } from "../../assets/icons";
import { PageActionButton } from "../page";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                padding: theme.spacing(1),
                "& svg": {
                    alignSelf: "center",
                },
            },
        }),
    { name: "MessageComposerIconButton" }
);

interface InnerMessageComposerIconButtonProps {
    classes?: Partial<ReturnType<typeof useStyles>>;
    // These are actually TooltipProps. They should be the most commonly modified when using this component.
    // We are modifying the name here to be more specific than the original provided in ToolTipProps.
    toolTipTitle?: string;
    toolTipPlacement?:
        | "bottom-end"
        | "bottom-start"
        | "bottom"
        | "left-end"
        | "left-start"
        | "left"
        | "right-end"
        | "right-start";
}

type MessageComposerIconButtonProps = InnerMessageComposerIconButtonProps &
    IconButtonProps &
    MessageComposerProps;

export const MessageComposerIconButton = (
    props: MessageComposerIconButtonProps,
    toolTipProps: TooltipProps
) => {
    const {
        id,
        classes: classesProp,
        leadId,
        leadName,
        jobId,
        jobName,
        initialRecipients,
        attachments,
        initialBodyText,
        replyMessageId,
        toolTipTitle = "send a message",
        toolTipPlacement = "bottom-start",
        ...iconButtonProps
    } = props;

    const {
        placement = toolTipPlacement,
        title = toolTipTitle,
        ...rest
    } = toolTipProps;

    const classes = mergeClasses(useStyles({}), classesProp);

    const [messageComposerOpen, setMessageComposerOpen] = React.useState(
        () => false
    );

    return (
        <>
            <Tooltip
                placement={placement}
                title={title}
                disableFocusListener
                {...rest}
            >
                <span>
                    <PageActionButton
                        id={id}
                        className={classes.root}
                        color="primary"
                        onClick={() => setMessageComposerOpen(true)}
                        {...iconButtonProps}
                    >
                        <NewMessageIcon />
                    </PageActionButton>
                </span>
            </Tooltip>
            {messageComposerOpen ? (
                <MessageComposer
                    leadName={leadName}
                    leadId={leadId}
                    jobName={jobName}
                    jobId={jobId}
                    open={messageComposerOpen}
                    initialRecipients={initialRecipients}
                    attachments={attachments}
                    initialBodyText={initialBodyText}
                    replyMessageId={replyMessageId}
                    onClose={() => setMessageComposerOpen(false)}
                />
            ) : null}
        </>
    );
};
